<template>
  <div>
    <ClientOnly>
      <component :is="icon" />
      <template #fallback>
        <div class="w-full h-full bg-shade-200 animate-pulse"></div>
      </template>
    </ClientOnly>
  </div>
</template>
<script lang="ts" setup>
import { getRandomIntInclusive } from '~/utils/math'

const props = defineProps({
  id: {
    type: Number,
    default: () => getRandomIntInclusive(1, 20),
  },
  thin: {
    type: Boolean,
    default: false,
  },
})

const glob = import.meta.glob('~/assets/icon/pattern/*', {
  eager: true,
})

const icon = computed(() => {
  return glob['/assets/icon/pattern/pattern_' + props.id + '.svg']
})
</script>
